module.exports = function() {
  return new Worker(__webpack_public_path__ + "48b3fb98bfe329c29274.worker.js");
};